import React from 'react';
import '../../App.css';
import CardGrid from "../CardGrid.js"

export default function Home() {
  const isSaral = process.env.REACT_APP_CLIENT_NAME === 'SARAL TRANSPORT';
  return (
    <div className={isSaral ? "home-saral" : "home"}>
      <CardGrid />
    </div>
  );
}
